import { connect } from 'react-redux';
import { getFaqDataWithStatuses, getSidebarDataWithStatuses } from 'store/selectors/resources';
import { getLocation } from 'store/selectors/router';
import Sidebar from 'components/Resources/Sidebar';

const mapStateToProps = state => ({
  location: getLocation(state),
  faqDataList: getFaqDataWithStatuses(state),
  dataList: getSidebarDataWithStatuses(state),
});

export default connect(mapStateToProps)(Sidebar);
